import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  rowText: {
    marginRight: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  leftHalf: {
    display: "flex",
    width: "65%",
    alignItems: "center",
    flexDirection: "column",
  },
  rightHalf: {
    display: "flex",
    width: "35%",
    flexDirection: "row",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  boardData: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  boardNameBox: {
    marginRight: "5px",
    width: "50%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      fontWeight: 600,
    },
  },
  dateBox: {
    marginRight: "5px",
    width: "30%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  statusBox: {
    width: "20%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "70%",
    },
  },
  buttonBox: {
    width: "15%",
  },
}))

export default styles
